import {FOUNDATION_DATA} from '../constant/index';

export const getFoundationPage = data =>{
return{
    type: FOUNDATION_DATA.GET_FOUNDATION_PAGE,
    payload : data,
    };
}